import { defineEffect } from '../../../core/effect';
import { posChangeMotionSpec } from '../fx/posChange';

/** 表示形式の変更（攻 ↔ 守）の **motion**: 盤のカードがくいっと回る（Issue #589。状況は共通側の `editorPorts/duelSituations/pos_change.js` が決め、絵の組み立ては `../fx/posChange.js`） */
export default defineEffect({ situation: 'pos_change_turn', role: 'motion', ...posChangeMotionSpec('turn') }, 'pos_change_turn_motion.js');
